export default "__VITE_ASSET__BAc_m6tr__"